<template>
  <div class="page-container-one">
    <div class="error-image" style="background-image: url(/img/404-one.png)"></div>
    <div class="text-content">
      <div class="text-two">抱歉，您访问的页面出错啦</div>
      <div class="text-one">建议你去别处看看...</div>
      <div class="button" @click="back()">去首页</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
  },
  name: "abnormalOne",
  inject: ['reload'],
  data() {
    return {
    }
  },
  methods: {
    ...mapActions([
    ]),
    // 返回
    back() {
      this.$router.push({ path: '/' })
    }
  },
  watch: {
  },
  computed: {
    ...mapGetters([
    ])
  },
  created() {
  },
  mounted() {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" rel="stylesheet/scss">
@import "../../assets/scss/variables";
@import "../../assets/scss/mixins";
.page-container-one {
  width: 100%;
  height: 100%;
  padding-top: 220px;
  background-color: $white;
  .error-image {
    width: 100%;
    height: 200px;
    background-position: center;
    background-repeat: no-repeat;
  }
  .text-content {
    padding-top: 10px;
    text-align: center;
  }

  .text-two {
    padding: 24px 0 12px 0;
    font-size: 20px;
    color: #2f2f4f;
    font-weight: bold;
  }
  .text-one {
    padding-bottom: 40px;
    font-size: 14px;
    color: #697386;
  }

  .button {
    width: 124px;
    margin: 0 auto;
    line-height: 42px;
    font-size: 17px;
    color: #0066ff;
    text-align: center;
    background-color: #ffffff;
    border: 1px solid #0066ff;
    border-radius: 2px;
    // &:hover {
    //   background-color: #0066ff;
    //   opacity: 0.8;
    // }
  }
}
</style>